<div class="d-flex popup-container">
  <div class="column right-column">
    <form [formGroup]="emailForm" (ngSubmit)="handleSubmit()">
      <div [ngSwitch]="currentCreateState()">
        <div *ngSwitchCase="CreateState.Begin">
            <h4 class="mb-3">Create disposable email relay</h4>

            <p class="mb-3">
              Provide your email address to create unique disposable email for your
              next cashbach purcheses with Quidco.
            </p>

            <div class="mb-1">
              <label for="userEmail">Email address</label>
              <input
                #emailInput
                id="userEmail"
                type="email"
                formControlName="email"
                class="form-control"
                placeholder=""
                [readOnly]="isEmailInputReadOnly()"
                required
              />
            </div>

            <div class="mb-4">
              <label for="taC">
                <input type="checkbox" id="taC" formControlName="taC" /> I agree to the <a href="javascript:">terms and conditions</a>
              </label>
            </div>

            <div class="mb-5">
              <button
                type="submit"
                class="btn btn-primary"
                [disabled]="emailForm.invalid"
              >Send confirmation email</button>
            </div>
        </div>

        <div *ngSwitchCase="CreateState.Sent">
          <h4 class="mb-3">Confirmation email sent</h4>

          <p class="mb-3">
            We've just sent a confirmation email to your private email. It can
            take a few minutes to arrive.Please check your mailbox and follow the
            steps.
          </p>

          <div class="mb-3">
            <label for="userEmail">Email address</label>
            <input
              #emailInput
              id="userEmail"
              type="email"
              formControlName="email"
              class="form-control"
              placeholder=""
              [readOnly]="isEmailInputReadOnly()"
              required
            />
          </div>

          <div class="d-flex flex-row gap-1 mb-1">
            <button
              type="submit"
              class="btn btn-primary"
              [disabled]="!isResendEnabled() || emailForm.invalid"
            >Resent email</button>

            <button
              type="button"
              class="btn btn-outline-primary"
              (click)="handleToggleEditEmailInput()"
              [disabled]="!isResendEnabled()"
            >Edit email address</button>
          </div>

          <p class="text-muted user-select-none">
            <small>
              @if (isResendEnabled()) { You can resend email now. }
              @else { You can resend in {{ timerRemainingSeconds() }} seconds. }
            </small>
          </p>

          <small><a href="javascript:">What if I haven’t received a confirmation email?</a></small>
        </div>
      </div>
    </form>

    <app-buttom-logo></app-buttom-logo>
  </div>
</div>
